import { Language } from "@/interfaces";
import httpClient, { ApiResponse } from "@/api/httpClient";

export const getAllLanguages = async (): Promise<ApiResponse<Language>> =>
  await httpClient.get(`/languages`);

export const getAllTranslations = async (languageId: string): Promise<ApiResponse<Language>> =>
  await httpClient.get(`/translation/tenant/${languageId}`);
